export const LANGUAGE_MAP = {
    'zh':'中文',
    'en':'英语',
    'th':'泰语',
    'vi':'越南语',
    'my':'缅甸语',
    'ja':'日语',
    'es':'西班牙语',
    'ko':'韩语',
    'fr':'法语',
    'de':'德语',
    'it':'意大利语',
    'pt':'葡萄牙语',
    'ru':'俄语',
    'id':'印度尼西亚语',
    'ms':'马来西亚语',
    'ar':'阿拉伯语',
    'hi':'印地语',
    'tr':'土耳其语',
    'pl':'波兰语',
    'uk':'乌克兰语',
    'sv':'瑞典语',
    'cs':'捷克语',
    'nl':'荷兰语',
}